import { StandardModal, Props as StandardModalProps } from '../StandardModal/StandardModal';
import { STANDARD_HEIGHT } from '../StandardModal/StandardModal.styles';
import {
  EmbeddedLightbox,
  LightboxHeader,
  STANDARD_WIDTH_APPOINTMENT_LIGHTBOX,
} from './AppointmentLightBoxModal.styles';

type Props = StandardModalProps & {
  iframeUrl: string;
  headerText?: string;
};

export const AppointmentLightBoxModal = ({
  iframeUrl,
  height,
  width,
  headerText,
  ...restProps
}: Props) => (
  <StandardModal
    width={width || STANDARD_WIDTH_APPOINTMENT_LIGHTBOX}
    height={height || STANDARD_HEIGHT}
    {...restProps}
  >
    {headerText && <LightboxHeader>{headerText}</LightboxHeader>}
    <EmbeddedLightbox src={iframeUrl} height={height || '600px'}></EmbeddedLightbox>
  </StandardModal>
);
